import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=22c258e2&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=22c258e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c258e2",
  null
  
)

export default component.exports